import { combineReducers } from "redux";

import { planFactSummaryReducer } from "./PlanFactSummary/model/slice";
import planFactVolumeReducer from "./PlanFactVolume/model/reducer";

export const planFactReducer = combineReducers({
  planFactVolumeReducer,
  planFactSummaryReducer,
});
